import {Component, Input, OnInit} from '@angular/core';
import {TilesService} from "../../core";

@Component({
    selector: 'circle-progress-thin',
    templateUrl: './circle-progress-thin.component.html',
    styleUrls: ['./circle-progress-thin.component.scss']
})
export class CircleProgressThinComponent implements OnInit {
    @Input() angleEnd: number;
    @Input() showPath: boolean;
    @Input() value: number;
    circlePath: string;

    constructor(
        private tiles: TilesService,
    ) {
    }

    ngOnInit() {
        const angleEnd = this.angleEnd ? this.angleEnd : 0;
        this.circlePath = this.tiles.calculateCirclePoints(27, 27, 27, 0, angleEnd, 2).toString();
    }
}
